import { CoreApi } from "../core/CoreApi";
import { API_ENDPOINTS } from "@libs/request/endpoints_helper";

class VoucherRequest extends CoreApi {
  list(input = {}) {
    return this.http
      .get(API_ENDPOINTS.voucherlist, { params: input })
      .then((res) => res.data);
  }
  view(id = "") {
    return this.http
      .get(`${API_ENDPOINTS.viewVoucher}/${id}`)
      .then((res) => res.data);
  }
  search(input = {}) {
    return this.http
      .get(`${API_ENDPOINTS.SEARCH}`, { params: input })
      .then((res) => res.data);
  }
  create(input = {}) {
    return this.http.post(API_ENDPOINTS, input).then((res) => res.data);
  }
  sendData(input = {}) {
    return this.http
      .post(API_ENDPOINTS.sendVoucherData, input)
      .then((res) => res.data);
  }

  paymentGet(input = {}) {
    return this.http
      .post(API_ENDPOINTS.sendVoucherPay, input)
      .then((res) => res.data);
  }
  getCart(input = {}) {
    return this.http
      .get(API_ENDPOINTS.voucherCart, { params: input })
      .then((res) => res.data);
  }
}
export const VoucherService = new VoucherRequest("auth");
